export const GET_LATEST_FILLED_APTITUDE_TEST_ATTEMPT = 'GET_LATEST_FILLED_APTITUDE_TEST_ATTEMPT';
export type GET_LATEST_FILLED_APTITUDE_TEST_ATTEMPT = typeof GET_LATEST_FILLED_APTITUDE_TEST_ATTEMPT;

export const GET_LATEST_FILLED_APTITUDE_TEST_SUCCESS = 'GET_LATEST_FILLED_APTITUDE_TEST_SUCCESS';
export type GET_LATEST_FILLED_APTITUDE_TEST_SUCCESS = typeof GET_LATEST_FILLED_APTITUDE_TEST_SUCCESS;

export const GET_LATEST_FILLED_APTITUDE_TEST_FAILURE = 'GET_LATEST_FILLED_APTITUDE_TEST_FAILURE';
export type GET_LATEST_FILLED_APTITUDE_TEST_FAILURE = typeof GET_LATEST_FILLED_APTITUDE_TEST_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/filled-test/get/Types.tsx